import React, { useState, useEffect, useContext } from "react";
import { IoIosClose } from "react-icons/io";
import "react-toastify/dist/ReactToastify.css";
import RequestService from "../../services/RequestService";
import MovementService, { addnewObservacao } from "../../services/MovementService";
import { parseISO, format, isValid } from "date-fns";
import { FaExchangeAlt } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Context } from '../../context/UserContext'
import { MdCancel } from "react-icons/md";
import DepositService from "../../services/DepositService"
import StatusRequests from '../../enums/StatusRequests'
import TiposGestao, { getDescricaoByCod } from "../../enums/TiposGestao";
import { ehUsuarioInterno } from "../../utils/roles";


export default function RequestDetailsModal({
  isModalOpen,
  setModalOpen,
  requestId,
  isGestao,
  // setTicketCb
}) {

  const [requestObject, setRequestObject] = useState();
  const [movements, setMovements] = useState([]);

  const [changeCodSapMode, setChangeCodSapMode] = useState(false)
  const [changeQtdAtender, setChangeQtdAtender] = useState(false)
  const [changeQtdCorte, setChangeQtdCorte] = useState(false)

  const [qtdAtender, setQtdAtender] = useState()
  const [qtdDesdobrar, setQtdDesdobrar] = useState()
  const [drsAtenderDesdobramento, setDrsAtenderDesdobramento] = useState()
  const [qtdCorte, setQtdCorte] = useState()

  const [depositList, setDepositList] = useState([]);

  const [novaObservacao, setNovaObservacao] = useState("");
  const [isLoadingObs, setIsLoadingObs] = useState(false);

  const [newObs, setNewObs] = useState(false);

  const [update, setUpdate] = useState(false);

  const { user } = useContext(Context)

  // Só usuários com role 'user' da empresa "AMERINODE - (SPML)" podem editar
  // o checkbox de Furto/Vandalismo. Os demais veem apenas a flag (read-only).
  const canEditFurtoVandalismo =
    ehUsuarioInterno(user) && user?.company?.name === 'AMERINODE - (SPML)';

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);

      //get all log movements from this request
      const data = await MovementService.getMovementsFromRequest(requestId)

      setMovements(data.requestMovements);

      const deposits = await DepositService.getDeposits();
      setDepositList(deposits);

    }

    fetchRequest();
  }, [isModalOpen, requestId, changeCodSapMode, changeQtdAtender, changeQtdCorte, update]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const statusColor = {
    "NOVO": "#fde047",
    "DEPOSITO": "#d8b4fe",
    "REPASSE PARA ENTREGA": "#bae6fd",
    "ROTA DE ENTREGA": "#38bdf8",
    "ENTREGUE": "#0369a1",
    "FINALIZADO": "#22c55e",
    "GESTAO": "#f87171"
  }

  const onClose = () => {
    // setRequestObject(null)
    setModalOpen(!isModalOpen)
    setChangeCodSapMode(false)
    setChangeQtdAtender(false)
    setChangeQtdCorte(false)
    setNovaObservacao("")
    setNewObs(false)
  };

  const handleChangeCodSap = () => {
    setChangeCodSapMode(true)
    setValue('codSap', requestObject?.request?.codSap,);
  };

  const handleChangeQtdAtender = () => {
    window.confirm('Essa ação acarretará em Desdobramento de Depósito, ou seja, será criado uma nova requisição do mesmo equipamento com a quantidade restante');
    setChangeQtdAtender(true)
    // setValue('quantidadeAtender', requestObject?.request?.quantidadeAtender);
    // setQtdAtender(requestObject?.request?.quantidadeAtender)
  };

  const handleChangeQtdCorte = () => {
    setChangeQtdCorte(true)
    // setValue('quantidadeAtender', requestObject?.request?.quantidadeAtender);
    setQtdCorte(requestObject?.request?.quantidadeCortada)
  };

  const handleSaveNewCodSap = async (data) => {
    console.log(data);

    // data = { ...data, status: "DEPOSITO" };

    const response = await RequestService.changeCodSapAlternativo(requestId, data);

    if (response) {
      toast.success("Código SAP alterado!");
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setChangeCodSapMode(false)
    // setModalOpen(!isModalOpen);
    // reset();
  };

  const handleSaveDesdobrar = async () => {
    // console.log(data);

    const body = { quantidadeDesdobrar: qtdDesdobrar, drsAtenderDesdobramento: drsAtenderDesdobramento};

    try {
      const response = await RequestService.updateParcial(requestId, body);
      toast.success(response.message);
      setChangeQtdAtender(false)

    } catch (error) {
        toast.error(error.message);
    }
  };

  // Alterna o atributo isFurtoVandalismo da Request a cada marcar/desmarcar
  // do checkbox. Atualização otimista (reflete na UI na hora) com reversão
  // caso o updateParcial falhe.
  const handleToggleFurtoVandalismo = async (e) => {
    if (!requestObject) return;
    const checked = e.target.checked;

    setRequestObject((prev) => ({
      ...prev,
      request: { ...prev.request, isFurtoVandalismo: checked },
    }));

    try {
      const response = await RequestService.updateParcial(requestId, { isFurtoVandalismo: checked });
      toast.success(response.message);
    } catch (error) {
      // Falha ao persistir o atributo — reverte o checkbox e aborta
      setRequestObject((prev) => ({
        ...prev,
        request: { ...prev.request, isFurtoVandalismo: !checked },
      }));
      toast.error(error.message);
      return;
    }

    // A flag já foi persistida — registra no histórico quem marcou/desmarcou.
    // Uma falha aqui não desfaz a alteração; apenas avisa.
    try {
      await addnewObservacao({
        requestId: requestObject?.request?._id,
        requestNro: requestObject?.request?.idRequest,
        oldStatus: "-",
        newStatus: "-",
        obsAtualizacao: checked
          ? "Flag Furto/Vandalismo marcada."
          : "Flag Furto/Vandalismo desmarcada.",
        carimbo: "-",
      });
      // Atualiza a lista de movimentações exibida no modal
      const data = await MovementService.getMovementsFromRequest(requestObject?.request?._id);
      setMovements(data.requestMovements);
    } catch (error) {
      toast.error("Alteração salva, mas não foi possível registrar no histórico.");
    }
  };

  const handleSaveNewQtdCorte = async (data) => {
    console.log(data);
    
    const body = { quantidadeCortada: data };

    try {
      await RequestService.updateParcial(requestId, body);
      toast.success("Quantidade cortada alterada com sucesso!");
      setChangeQtdCorte(false)
      
    } catch (error) {
        toast.error(error.message);
    }

  };

  const handleCancelDesdobramentos = async (requestId) => {
    try {
      await RequestService.cancelDesdobramentos(requestId);
      toast.success("Todos os desdobramentos cancelados");
      setChangeQtdCorte(false)
      
    } catch (error) {
        toast.error(error.message);
    }
    setModalOpen(!isModalOpen);
  }

  const handleAddObservacao = async () => {
    if (!novaObservacao.trim()) {
      toast.error("Digite uma observação.");
      return;
    }
    setIsLoadingObs(true);
    try {
      await addnewObservacao({
        requestId: requestObject?.request?._id,
        requestNro: requestObject?.request?.idRequest,
        oldStatus: "-",
        newStatus: "-",
        obsAtualizacao: novaObservacao,
        carimbo: "-"
      });
      toast.success("Observação adicionada!");
      setNovaObservacao("");
      // Atualiza movimentações
      const data = await MovementService.getMovementsFromRequest(requestObject?.request?._id);
      setMovements(data.requestMovements);
      setUpdate(!update);
    } catch (error) {
      toast.error(error?.message || "Erro ao adicionar observação.");
    }
    setIsLoadingObs(false);
  };

  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "N/A";
    try {
      const d = typeof dateValue === "string" ? parseISO(dateValue.trim()) : new Date(dateValue);
      return isValid(d) ? format(d, "dd/MM/yy HH:mm") : "N/A";
    } catch {
      return "N/A";
    }
  };

  const equipmentRows = (requestObject?.request?.equipamentos && requestObject?.request?.equipamentos.length > 0)
    ? requestObject.request.equipamentos
    : requestObject?.request
    ? [{
        _id: requestObject.request._id,
        codSap: requestObject.request.codSap,
        nomeEquipamento: requestObject.request.nomeEquipamento,
        partNumberEquipamento: requestObject.request.partNumberEquipamento,
        fabricanteEquipamento: requestObject.request.fabricanteEquipamento,
        quantidade: requestObject.request.quantidadeSolicitada,
      }]
    : [];

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div
          className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-fit min-w-[700px] max-w-[780px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all">
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg" onClick={(e) => e.stopPropagation()}>
                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 text-white text-xl font-bold">
                    <div>SOLICITAÇÃO</div>
                    <div>
                      # {requestObject?.request?.idRequest}
                    </div>
                  </div>
                  {requestObject?.request?.isReplica &&
                    <div className="text-xs flex items-center gap-1">
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                  {(requestObject?.request?.tipoAtendimento === 'bbn-alta' || requestObject?.request?.tipoAtendimento === 'bbn-media') &&
                    <div className="text-md flex items-center gap-1">
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        BBN
                      </p>
                    </div>
                  }

                </div>
                <div className="flex gap-4 justify-between text-xs">
                <div>Criado em: {formatDateSafe(requestObject?.request?.createdAt)}</div>
                <div>Atender até: {formatDateSafe(requestObject?.request?.slaDate)}</div>
                  {canEditFurtoVandalismo ? (
                    <label className="flex gap-1 items-center font-bold whitespace-nowrap cursor-pointer select-none">
                      <input
                        type="checkbox"
                        checked={!!requestObject?.request?.isFurtoVandalismo}
                        onChange={handleToggleFurtoVandalismo}
                        className="cursor-pointer accent-red-500"
                      />
                      <span className={requestObject?.request?.isFurtoVandalismo ? "text-red-200" : "text-gray-400"}>
                        Furto/Vand.
                      </span>
                    </label>
                  ) : (
                    requestObject?.request?.isFurtoVandalismo && (
                      <div className="flex gap-1 items-center text-red-200 font-bold whitespace-nowrap">
                        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
                        <span>Furto/Vand.</span>
                      </div>
                    )
                  )}
                  <div className="flex gap-1 items-center">
                    Status:
                    <p  className="text-black rounded-lg px-1"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col gap-2 mt-2" onClick={(e) => e.stopPropagation()}>
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-2 text-[11px]">
                    {/* DIV Motivo do cancelamento (só aparece quando há valor) */}
                    {requestObject?.request?.motivoCancelamento && (
                      <div className="flex flex-col gap-1 py-2 px-4 bg-red-50 border border-red-200 rounded-md">
                        <label className="block text-red-700 font-bold whitespace-nowrap">
                          Motivo do cancelamento:
                        </label>
                        <div className="text-gray-800 whitespace-pre-wrap">
                          {requestObject?.request?.motivoCancelamento}
                        </div>
                      </div>
                    )}

                    {/* DIV Justificativa (só aparece quando há valor) */}
                    {requestObject?.request?.justificativa && (
                      <div className="flex flex-col gap-1 py-2 px-4 bg-amber-50 border border-amber-200 rounded-md">
                        <label className="block text-amber-800 font-bold whitespace-nowrap">
                          Justificativa:
                        </label>
                        <div className="text-gray-800 whitespace-pre-wrap">
                          {requestObject?.request?.justificativa}
                        </div>
                      </div>
                    )}

                    {/* DIV Usuario */}
                    <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
                      <div className="absolute right-4 top-2 text-blue-400 font-bold">
                        <a href="#">Ver mais</a>
                      </div>

                      <div className="flex flex-row gap-8 w-full">
                        <div className="flex items-start gap-1 w-1/2">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Nome Solicitante:
                          </label>
                          <div>{requestObject?.request?.nomeSolicitante}</div>
                        </div>
                        <div className="flex items-start gap-1  w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            RE/Legal Solicitante:
                          </label>
                          <div>
                            {requestObject?.request?.reLegalSolicitante}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row gap-8 w-full">
                        <div className="flex items-start gap-1  w-1/2">
                          <label className="block text-gray-700 font-bold">
                            UF:
                          </label>
                          <div>{requestObject?.request?.uf}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Empresa:
                          </label>
                          <div>{requestObject?.request?.empresaSolicitante}</div>
                        </div>
                      </div>
                    </div>

                    {/* DIV Equipamento */}
                    <div className="flex bg-gray-50 border rounded-md relative">

                      <div className="flex flex-col flex-1 min-w-0">
                          <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm">
                            <table className="min-w-full text-[10px] text-left text-gray-700">
                              <thead className="bg-gray-200">
                                <tr>
                                  <th colSpan="5" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                                    Equipamentos
                                  </th>
                                </tr>
                                <tr>
                                  <th className="px-2 py-1">Cod. Sap</th>
                                  <th className="px-2 py-1">Nome</th>
                                  <th className="px-2 py-1">Part Number</th>
                                  <th className="px-2 py-1">Fabricante</th>
                                  <th className="px-2 py-1 text-center">Qtd</th>
                                </tr>
                              </thead>
                              <tbody>
                                {equipmentRows.map((equipment) => (
                                  <tr key={equipment._id || `${equipment.codSap}-${equipment.partNumberEquipamento}`} className="border-t border-zinc-200 align-top">
                                    <td className="px-2 py-1 whitespace-nowrap">{equipment.codSap}</td>
                                    <td className="px-2 py-1 whitespace-normal">{equipment.nomeEquipamento}</td>
                                    <td className="px-2 py-1 whitespace-nowrap">{equipment.partNumberEquipamento}</td>
                                    <td className="px-2 py-1 whitespace-nowrap">{equipment.fabricanteEquipamento}</td>
                                    <td className="px-2 py-1 text-center">{equipment.quantidade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {requestObject?.request?.status === 'GESTAO' && ehUsuarioInterno(user) && !changeCodSapMode && (
                            <div className="flex items-center justify-end pt-2">
                              <button className="flex items-center gap-1 text-blue-400 hover:text-blue-500" title="Trocar SAP" onClick={handleChangeCodSap}>
                                <FaExchangeAlt size={15} />
                                SAP alternativo
                              </button>
                            </div>
                          )}

                          {(changeCodSapMode || requestObject?.request?.codSapAlternativo) &&
                            <div className="flex flex-col gap-2">
                              {!changeCodSapMode && requestObject?.request?.codSapAlternativo && (
                                <div className="flex items-start gap-1 text-blue-500">
                                  <label className="block font-bold whitespace-nowrap">
                                    *atendendo com SAP alternativo:
                                  </label>
                                  <div>{requestObject?.request?.codSapAlternativo}</div>
                                </div>
                              )}

                              {changeCodSapMode && (
                                <div className="flex items-start gap-2">
                                  <input
                                    type="text"
                                    {...register("codSapAlternativo", {
                                      required: true,
                                      validate: value => value.replace(/\s/g, '').length > 0
                                    })}
                                    onChange={e => {
                                      const cleaned = e.target.value.replace(/\s/g, '');
                                      setValue("codSapAlternativo", cleaned, { shouldValidate: true });
                                    }}
                                    className={`block w-48 rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                    ${errors?.codSapAlternativo?.type === "required"
                                        ? " border border-red-500 outline-none ring-0"
                                        : "border border-zinc-500 outline-none ring-0"
                                      }
                                    `}
                                  />
                                  <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => handleSubmit(handleSaveNewCodSap)()}>
                                    Salvar
                                  </button>
                                  <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => setChangeCodSapMode(false)}>
                                    Cancelar
                                  </button>
                                </div>
                              )}

                              {errors?.codSapAlternativo?.type === "required" && (
                                <p className="text-red-500 ms-2">
                                  Campo obrigatório
                                </p>
                              )}
                            </div>
                          }
                      </div>
                      

                      <div className="flex flex-col w-[290px] shrink-0">
                        <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm">
                          <table className="min-w-full text-[10px] text-left text-gray-700">
                            <thead className="bg-gray-200">
                              <tr>
                                <th colSpan="3" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                                  Quantidades
                                </th>
                              </tr>
                              <tr>
                                <th className="px-2 py-1">Metrica</th>
                                <th className="px-2 py-1 text-center">Valor</th>
                                {requestObject?.request?.status === 'GESTAO' && (
                                  <th className="px-2 py-1 text-center">Ação</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="border-t border-zinc-200 align-middle">
                                <td className="px-2 py-1 font-bold text-gray-700">Qtd Solicitada</td>
                                <td className="px-2 py-1 text-center">{requestObject?.request?.quantidadeSolicitada}</td>
                                {requestObject?.request?.status === 'GESTAO' && (
                                  <td className="px-2 py-1"></td>
                                )}
                              </tr>
                              <tr className="border-t border-zinc-200 align-middle">
                                <td className="px-2 py-1 font-bold text-gray-700">Qtd Cortada</td>
                                <td className="px-2 py-1 text-center">
                                  {!changeQtdCorte ? (
                                    requestObject?.request?.quantidadeCortada
                                  ) : (
                                    <div className="flex justify-center">
                                      <input
                                        required
                                        type="text"
                                        defaultValue={qtdCorte}
                                        className="block rounded-md ps-1 w-12 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                                        onChange={(e)=>{setQtdCorte(e.target.value)}}
                                      />
                                    </div>
                                  )}
                                </td>
                                {requestObject?.request?.status === 'GESTAO' && (requestObject?.request?.tipoAtendimento !== 'bbn-alta' || requestObject?.request?.tipoAtendimento !== 'bbn-media') && (
                                  <td className="px-2 py-1 text-center">
                                    {changeQtdCorte ? (
                                      <div className="flex items-center justify-center gap-2">
                                        <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => handleSaveNewQtdCorte(qtdCorte)}>
                                          Salvar
                                        </button>
                                        <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => setChangeQtdCorte(false)}>
                                          Cancelar
                                        </button>
                                      </div>
                                    ) : (
                                      ehUsuarioInterno(user) && (requestObject?.request?.tipoAtendimento !== 'bbn-alta' && requestObject?.request?.tipoAtendimento !== 'bbn-media') &&
                                      <button className="underline text-blue-400 cursor-pointer" title="Trocar quantidade a ser atendida" onClick={handleChangeQtdCorte}>Corte</button>
                                    )}
                                  </td>
                                )}
                              </tr>
                              <tr className="border-t border-zinc-200 align-middle">
                                <td className="px-2 py-1 font-bold text-gray-700">Qtd a Atender</td>
                                <td className="px-2 py-1 text-center">{requestObject?.request?.quantidadeAtender}</td>
                                {requestObject?.request?.status === 'GESTAO' && (requestObject?.request?.tipoAtendimento !== 'bbn-alta' && requestObject?.request?.tipoAtendimento !== 'bbn-media') && (
                                  <td className="px-2 py-1 text-center">
                                    {ehUsuarioInterno(user) && 
                                      <button className="underline text-blue-400 cursor-pointer" title="Trocar quantidade a ser atendida" onClick={handleChangeQtdAtender}>Parcial</button>
                                    }
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {changeQtdAtender && 
                        <div className="flex flex-col items-center justify-center gap-2 w-full border border-red-500 rounded-md mb-2 px-2 py-1">
                          <div className="flex items-start justify-start gap-3 w-full">
                            <div className="flex flex-col gap-1 items-center w-full">
                            <label className="text-gray-700 font-bold">Qtd Desdobrar:</label>
                              <input
                                //   disabled={true}
                                required
                                type="number"
                                min={1}
                                // defaultValue={qtdAtender}
                                className={`block rounded-md ps-1 w-10 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0`}
                                onChange={(e)=>{setQtdDesdobrar(e.target.value)}}
                              />
                            </div>

                            <div className="flex flex-col items-start gap-1 w-full">
                                <label className="text-gray-700 font-bold">
                                  DRS Atender:
                                </label>
                                <select
                                  defaultValue="0"
                                  onChange={(e)=>setDrsAtenderDesdobramento(e.target.value)}
                                  className="block w-40 rounded-md px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                                >
                                  <option value="0" disabled>
                                    Escolha um depósito de origem
                                  </option>
                                  {depositList?.deposits?.map((deposit) => (
                                      <option key={deposit._id} value={deposit._id}>
                                          {deposit.cidade} - {deposit.sigla}
                                      </option>
                                  ))}
                                </select>
                                {errors?.drsAtender?.type === "validate" && (
                                  <p className="text-red-500 whitespace-nowrap">
                                    Depósito a atender é obrigatório
                                  </p>
                                )}
                            </div>
                          </div>
                            
                          <div className="flex gap-4">
                              <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => handleSaveDesdobrar()}>
                                Salvar
                              </button>
                              <button className="text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => setChangeQtdAtender(false)}>
                                Cancelar
                              </button>
                          </div>

                        </div>
                        }
                        { (requestObject?.request?.status === 'GESTAO' && ehUsuarioInterno(user)) && requestObject?.request?.idRequest.length <= 11 && requestObject?.request?.desdobramentos.length > 0 && 
                        <div className="flex items-start justify-start gap-1 w-full">
                          <button className="flex items-center gap-1 text-blue-400 hover:text-blue-500 underline" title="Trocar SAP" onClick={() => handleCancelDesdobramentos(requestObject?.request?._id)}>
                            <MdCancel color={'red'}/>
                            Cancelar Desdobramentos
                          </button>
                        </div>
                        }
                        
                        {/* <div className="flex items-start gap-1">
                          <label className="block text-blue-800 text-sm font-bold">
                            Resta Atender:
                          </label>
                          <div className="block text-blue-800 text-sm font-bold">{requestObject?.request?.quantidadeRestaAtender}</div>
                        </div> */}
                      </div>

                    </div>

                    {/* DIV Boleto */}
                    <div className="flex py-2 px-4 bg-gray-50 border rounded-md relative">
                      <div className="flex flex-row gap-6 w-full whitespace-nowrap">
                        <div className="flex items-start gap-1 w-1/2">
                          <label className="block text-gray-700 font-bold">
                            Identificação Boleto:
                          </label>
                          <div>{requestObject?.request?.idBoleto}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Tipo Boleto:
                          </label>
                          <div>{requestObject?.request?.tipoBoleto.toUpperCase()}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Tipo Atendimento:
                          </label>
                          <div>{requestObject?.request?.tipoAtendimento.toUpperCase()}</div>
                        </div>
                      </div>
                    </div>

                    {/* div Site */}
                    <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
                      <div className="flex flex-row gap-8 w-full whitespace-nowrap">
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Site:
                          </label>
                          <div>{requestObject?.request?.site}</div>
                        </div>
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold">
                            GMO:
                          </label>
                          <div>
                            {requestObject?.request?.gmo?.cidade}
                            {requestObject?.request?.gmo?.identificador ? (' - '+requestObject?.request?.gmo?.identificador) : ''}
                          </div>
                        </div>
                        <div className="flex items-start gap-1 w-1/2">
                          <label className="block text-gray-700 font-bold">
                            DRS Original:
                          </label>
                          <div>{requestObject?.request?.drsOriginal?.sigla}</div>
                        </div>
                        <div className="flex items-start gap-1 w-1/2">
                          <label className="block text-gray-700 font-bold">
                            DRS Atender:
                          </label>
                          <div>{requestObject?.request?.drsAtender?.sigla ? requestObject?.request?.drsAtender?.sigla : '-'}</div>
                        </div>
                      </div>
                      <div className="flex flex-row gap-8 w-full">
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold">
                            Endereço GMO:
                          </label>
                          <div>{requestObject?.request?.gmo?.endereco}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold">
                            Cidade GMO:
                          </label>
                          <div>{requestObject?.request?.gmo?.cidade}</div>
                        </div>
                      </div>

                    </div>

                    {/* div Contato */}
                    <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
                      <div className="flex flex-row gap-8 w-full">
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            RE Técnico:
                          </label>
                          <div>{requestObject?.request?.reTecnico}</div>
                        </div>
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Técnico:
                          </label>
                          <div>{requestObject?.request?.tecnico}</div>
                        </div>
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Empresa Técnico:
                          </label>
                          <div>{requestObject?.request?.empresaTecnico?.socialName}</div>
                        </div>
                        <div className="flex items-start gap-1">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Telefone:
                          </label>
                          <div>
                            {requestObject?.request?.telefone}
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-row gap-8 w-full">
                        <div className="flex items-start gap-1 w-fit whitespace-nowrap">
                          <label className="block text-gray-700 font-bold ">
                            Endereço Entrega:
                          </label>
                          <div>{requestObject?.request?.enderecoEntrega}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Cidade Entrega:
                          </label>
                          <div>{requestObject?.request?.cidadeEntrega}</div>
                        </div>
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Complemento:
                          </label>
                          <div>{requestObject?.request?.enderecoEntregaComplemento}</div>
                        </div>
                      </div>
                    </div>

                    {/* CÓDIGOS DE BARRAS */}
                    { requestObject?.request?.codItemsAtendidos.length > 0 && 
                    <div className="flex flex-col px-4 py-2 bg-gray-50 border rounded-md relative">
                      <div className="font-bold text-gray-700">Itens:</div>
                      <div className="flex flex-col gap-1 mt-2">
                        <div
                          className="w-full h-[100px] overflow-y-auto bg-white border border-zinc-300 rounded-md"
                        >
                          {requestObject?.request?.codItemsAtendidos && requestObject?.request?.codItemsAtendidos.length > 0 ? (
                            <table className="min-w-full text-xs text-left text-gray-500">
                              <thead className="bg-gray-200 text-gray-700">
                                <tr>
                                  <th className="px-1 py-1">#</th>
                                  <th className="px-1 py-1">Código de Barras</th>
                                </tr>
                              </thead>
                              <tbody>
                                {requestObject.request.codItemsAtendidos.map((item, index) => (
                                  <tr key={index} className="border-b text-xs">
                                    <td className="px-1 py-1">{index + 1}</td>
                                    <td className="px-1 py-1">{item}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div className="text-xs text-gray-500">Nenhum código de barras disponível.</div>
                          )}
                        </div>
                      </div>
                    </div>
                    }

                    {isGestao &&

                      <div className="flex flex-col px-4 bg-red-100 border rounded-md">
                        <div className="flex flex-row gap-2 w-full">
                        <div className="flex items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Motivo Gestão:</label>
                          <div>{requestObject?.request?.motivoEnvioGestao} - {getDescricaoByCod(requestObject?.request?.motivoEnvioGestao)}</div>                          
                        </div>
                        </div>
                      </div>
                    }

                    {/* div Observação */}
                    <div className="flex flex-col pt-4 px-4 bg-gray-50 border rounded-md">
                      <div className="flex flex-row gap-2 w-full">
                        <div className="flex flex-col items-start gap-1 mb-4 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Observação do solicitante:</label>
                          <textarea
                            disabled={true}
                            value={requestObject?.request?.observacao}
                            className={`
                                  w-full h-[60px] p-4 bg-white rounded-lg border border-zinc-300 justify-start items-center inline-flex resize-none 
                                  text-neutral-600 font-normal font-['Work Sans']
                                  focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                  placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              `}
                          />
                        </div>
                        <div className="flex flex-col items-start gap-1 mb-4 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Última observação:</label>
                          <textarea
                            disabled={true}
                            value={requestObject?.request?.ultimaObs}
                            className={`
                                  w-full h-[60px] p-4 bg-white rounded-lg border border-zinc-300 justify-start items-center inline-flex resize-none 
                                  text-neutral-600 font-normal font-['Work Sans']
                                  focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                                  placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              `}
                          />
                        </div>
                      </div>
                    </div>

                    {/* DIV movimentações */}
                    {movements.length !== 0 &&
                      <div className="flex flex-col w-full max-h-96 overflow-y-auto overflow-x-hidden">
                        <div className="flex flex-col">
                          <div className="flex justify-between items-center">
                            <div className="font-bold ms-2 mb-1">MOVIMENTAÇÕES:</div>
                            { ehUsuarioInterno(user) &&
                              <button
                                className="text-blue-400 hover:text-blue-500 underline me-2"
                                onClick={() => setNewObs(!newObs)}
                              >+ Observação
                              </button>
                            }
                          </div>
                          { newObs && 
                          <div className="flex items-center justify-between px-2 mb-2">
                            {/* input de texto para adicionar nova observação */}
                            <input
                              type="text"
                              value={novaObservacao}
                              onChange={e => setNovaObservacao(e.target.value)}
                              placeholder="Adicionar nova observação"
                              className="w-full rounded-md px-2 py-1 border border-zinc-400 text-xs"
                            />
                            <button
                              className="ml-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 text-xs whitespace-nowrap"
                              onClick={handleAddObservacao}
                              disabled={isLoadingObs}
                            >
                              {isLoadingObs ? "Salvando..." : "Adicionar"}
                            </button>
                          </div>
                          }
                        </div>
                        {/* table-fixed + larguras percentuais: o conteúdo quebra dentro
                            da coluna em vez de esticar a tabela e criar rolagem horizontal. */}
                        <table className="w-full table-fixed bg-white text-[11px]">
                          <thead>
                            <tr className="bg-gray-800 text-white border-b">
                              <th className="px-1 py-1 rounded-tl-lg w-[13%]">Data</th>
                              <th className="px-1 py-1 w-[16%]">Usuário</th>
                              <th className="px-1 py-1 w-[13%]">Status Anterior</th>
                              <th className="px-1 py-1 w-[4%]"></th>
                              <th className="px-1 py-1 w-[13%]">Status Novo</th>
                              <th className="px-1 py-1 w-[27%]">Obs</th>
                              <th className="px-1 py-1 rounded-tr-lg w-[14%]">Carimbo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {movements?.slice().reverse().map((movement) => (
                              <tr key={movement._id} className="align-top">
                                <td className="px-1 py-1 whitespace-nowrap border-b">{format(parseISO(movement.createdAt), 'dd/MM/yy HH:mm')}</td>
                                <td className="px-1 py-1 border-b break-words">{movement.user.userName}</td>
                                <td className="px-1 py-1 border-b break-words">{movement.oldStatus}</td>
                                <td className="px-1 py-1 border-b text-center"> {">>"} </td>
                                <td className="px-1 py-1 border-b break-words">{movement.newStatus}</td>
                                <td className="px-1 py-1 border-b text-[10px] break-words whitespace-pre-wrap">{movement.obsAtualizacao ? movement.obsAtualizacao : '-'}</td>
                                <td className="px-1 py-1 border-b text-[10px] break-words">{movement.carimbo ? movement.carimbo : '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
